import { Button, Text, Dialog, CloseButton } from '@chakra-ui/react';
import { ResponsiveModal } from '../shared'

interface DeleteTagModalProps {
  isOpen: boolean
  onClose: () => void
  tagLabel: string
  contactCount: number
  isLoading: boolean
  onConfirm: () => void
}

export function DeleteTagModal({
  isOpen,
  onClose,
  tagLabel,
  contactCount,
  isLoading,
  onConfirm,
}: DeleteTagModalProps) {
  return (
    <ResponsiveModal isOpen={isOpen} onClose={onClose} size="md">
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content>
          <Dialog.Header>Delete Tag</Dialog.Header>
          <Dialog.CloseTrigger asChild><CloseButton size="sm" /></Dialog.CloseTrigger>
          <Dialog.Body>
            <Text>
              Are you sure you want to delete the tag <strong>{tagLabel}</strong>?
            </Text>
            {contactCount > 0 && (
              <Text mt={2} color="orange.600" fontSize="sm">
                This tag is currently assigned to {contactCount} contact(s). It will be
                marked inactive and no longer assignable.
              </Text>
            )}
          </Dialog.Body>
          <Dialog.Footer>
            <Button variant="ghost" mr={3} onClick={onClose} size="sm">
              Cancel
            </Button>
            <Button
              colorPalette="red"
              onClick={onConfirm}
              loading={isLoading}
              size="sm"
            >
              Delete
            </Button>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog.Positioner>
    </ResponsiveModal>
  );
}
